module.exports = __webpack_public_path__ + "img/a-ziyuan12.496da1a1.png";